export const isRouteAllowed = (routes: string[], currentPath: string) => (
  routes.some((route) => {
    const regex = new RegExp('^' + route.replace(/:\w+/g, '[^/]+') + '$');
    return regex.test(currentPath || '');
  })
);
